/**
 * Product feature flags for this release.
 * Override with VITE_FEATURE_*=true in apps/web/.env (restart Vite after changes).
 * Pair with the matching FEATURE_* flag on the API.
 */
export const FEATURES = {
  /** Document upload / AI extraction / apply-to-employee flow */
  documents: import.meta.env.VITE_FEATURE_DOCUMENTS === 'true',
  /** Chat screenshot / file attachments (MarkItDown preprocess) */
  chatAttachments: import.meta.env.VITE_FEATURE_CHAT_ATTACHMENTS === 'true',
} as const;

export type FeatureFlag = keyof typeof FEATURES;
